import { render, staticRenderFns } from "./LoyaltyPanel.vue?vue&type=template&id=a44d0944"
import script from "./LoyaltyPanel.vue?vue&type=script&lang=js"
export * from "./LoyaltyPanel.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyPanel.vue?vue&type=style&index=0&id=a44d0944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports